import { useCartContext } from "app/providers/CartProvider";
import { useOrderContext } from "app/providers/OrderProvider";
import CheckoutBumbalHeader from "entities/checkout/bumbal-header";
import CheckoutPanelReceiveMethodsHeader from "entities/checkout/standard-product-receive-methods-header";
import { useMemo, useState } from "react";
import Card from "shared/ui/card";
import CheckoutAppointmentType from "widgets/checkout/appointment-type";
import CheckoutDoorAppointmentFooter from "widgets/checkout/door-appointment-footer";
import CheckoutSelfAssemblyAppointmentFooter from "widgets/checkout/self-assembly-appointment-footer";
import CheckoutPanelAppointmentFooter from "widgets/checkout/standard-product-appointment-footer";
import StandardProductReceiveMethods from "widgets/checkout/standard-product-receive-method";

const CheckoutAppointment = () => {
  const cart = useCartContext().getCart();

  const { order } = useOrderContext();

  const [selectedDate, setSelectedDate] = useState<Date | null>(null);
  const [planAppointmentLater, setPlanAppointmentLater] = useState(false);

  const showPanel = useMemo(
    () => !!cart.standardProducts.length,
    [cart.standardProducts],
  );

  const showSelfAssemblyFooter = order?.isSelfAssembly;
  return (
    <>
      <Card
        className="gg-border-b gg-border-t gg-px-4 sm:gg-px-14 2xl:gg-px-32"
        shadow={false}
      >
        {showPanel ? (
          <section className="gg-grid gg-grid-cols-12 gg-py-14">
            <CheckoutPanelReceiveMethodsHeader className="gg-col-span-12 gg-mb-10 lg:gg-col-span-4 lg:gg-mb-0 lg:gg-pr-10 xl:gg-pr-24" />
            <StandardProductReceiveMethods className="gg-col-span-12 lg:gg-col-span-8" />
          </section>
        ) : (
          <></>
        )}

        <section className="gg-grid gg-grid-cols-12">
          {!showPanel && (
            <>
              <CheckoutBumbalHeader className="gg-col-span-12 gg-mb-10 gg-py-14 lg:gg-col-span-4 lg:gg-mb-0 lg:gg-pr-10 xl:gg-pr-24" />
              <CheckoutAppointmentType
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                planAppointmentLater={planAppointmentLater}
                setPlanAppointmentLater={setPlanAppointmentLater}
                className="gg-col-span-12 lg:gg-col-span-8"
              />
            </>
          )}
        </section>
      </Card>

      {showPanel ? (
        <CheckoutPanelAppointmentFooter />
      ) : showSelfAssemblyFooter ? (
        <CheckoutSelfAssemblyAppointmentFooter
          selectedDate={selectedDate}
          planAppointmentLater={planAppointmentLater}
        />
      ) : (
        <CheckoutDoorAppointmentFooter
          selectedDate={selectedDate}
          planAppointmentLater={planAppointmentLater}
        />
      )}
    </>
  );
};
export default CheckoutAppointment;
